import ViewBase from "../view-base.view";
import { Button, Icons, Intent, Size } from "construct-ui";
import Sortable from 'sortablejs';

export default function SurveySubCategoryView() {
  ViewBase.call(this);
  let onQuestionClicked = () => { };
  let onDelete = () => { };
  let surveyId = "";
  let surveyIdString = "";
  let inputFilter = [];

  let createGuid = () => {
    return Math.floor(Math.random() * 1000000);//generate in between 0 and 1000000
  }

  let _addSurvey = () => {
    let survey = {
      survey: "",
      expand: false,
      surveyId: createGuid(),
      subSurvey: [
        {
          expand: false,
          name: "",
          subSurveyId: createGuid(),
          usedYN: [],
          mandatory: [],
          parentQuestion: "",
          questionType: [],
          parentAnsId: "",
          options: []
        }
      ]
    };
    inputFilter.push(survey);
  }

  return {
    oninit: function (vnode) {
      _addSurvey();

      if (vnode.attrs.onQuestionClicked) {
        onQuestionClicked = vnode.attrs.onQuestionClicked;
      }

      if (vnode.attrs.onDelete) {
        onDelete = vnode.attrs.onDelete;
      }

      if (vnode.attrs.surveyId) {
        surveyId = vnode.attrs.surveyId;
      }

      if (vnode.attrs.surveyIdString) {
        surveyIdString = vnode.attrs.surveyIdString;
      }
    },
    oncreate: function (vnode) {
        const subCategoryList = document.getElementById("surveyQsSubCategory" + surveyId);
        new Sortable(subCategoryList, {
            animation: 150,
            ghostClass: 'sortable-ghost',
            dragClass: 'sortable-drag',
            handle: '.drag-grip',
        });
    },
    view: (vnode) => {
      const expandClass = vnode.attrs.expand ? "show" : ""; // Use ternary operator for clarity

      return [
        m(".collapse", {
          id: "survey_" + vnode.attrs.surveyId,
          class: expandClass,
        },
          m('ul#surveyQsSubCategory' + surveyId + '.moveable_background-none',
            vnode.attrs.subSurvey && vnode.attrs.subSurvey.map(subSurvey =>
              m('li.mt-1.drag-grip',
                m('.survey-sub-category-item.d-flex.align-items-center',
                  m('i.bi-grip-vertical.px-2'),
                  m('.flex-grow-1.pe-3',
                    m('input[type="hidden"][value="' + subSurvey.subSurveyId + '"]'),
                    m('input[type="text"][value="' + subSurvey.name + '"].form-control', {
                      placeholder:this.getText("LT00000505", "Survey Sub Category"),
                      disabled: parseInt(surveyIdString) < 0,
                      onkeyup: (e) => { subSurvey.name = e.target.value }
                    })
                  ),
                  m('.p-2',
                    m('.d-flex.justify-content-end.align-items-center.gap-2',
                      m(Button, {
                        iconLeft: Icons.PLUS,
                        intent: Intent.PRIMARY,
                        label: this.getText("LT00000506", "Questions") + " (" + subSurvey.questions.length + ")",
                        outlined: true,
                        rounded: true,
                        size: Size.XS,
                        onclick: () => {
                          if (vnode.attrs.subSurvey) {
                            onQuestionClicked(subSurvey,vnode.attrs.maxQnId);
                          }
                        }
                      }),
                      m(Button, {
                        iconLeft: Icons.TRASH,
                        intent: Intent.NEGATIVE,
                        outlined: true,
                        disabled: parseInt(surveyIdString) < 0,
                        rounded: true,
                        size: Size.XS,
                        onclick: () => { onDelete(subSurvey.subSurveyId); }
                      })
                    ),
                  ),
                )
              )
            )
          ),
        ), this.getBaseViews()];
    }
  }
}
